import { render, staticRenderFns } from "./TableOrderComplete.vue?vue&type=template&id=51459932&scoped=true&"
import script from "./TableOrderComplete.vue?vue&type=script&lang=js&"
export * from "./TableOrderComplete.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=51459932&lang=less&scoped=true&"
import style1 from "../../less/tableOrder.less?vue&type=style&index=1&id=51459932&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51459932",
  null
  
)

export default component.exports